<template>
  <div class="page-wrapper">
    <!-- Page Title -->
    <div class="page-title-section">
      <h1 class="page-title">Corse</h1>
      <p class="page-subtitle">Gestisci lo storico, gli ordini attivi e le prenotazioni future</p>
    </div>

    <!-- Cards Navigation -->
    <el-row :gutter="24" justify="center" class="cards-row">
      <el-col :xs="24" :sm="12" :md="8">
        <CardComponent
          :imgSrc="corsePassateImg"
          title="STORICO ORDINI"
          label="Ordini conclusi"
          linkPath="/corse/corse_passate"
          @click="handleCardClickPassate"
          :isRouter="true"
        ></CardComponent>
      </el-col>
      <el-col :xs="24" :sm="12" :md="8">
        <CardComponent
          :imgSrc="corseAttiveImg"
          title="ORDINI LIVE"
          label="Prenotazioni in corso"
          linkPath="/"
          parameters="1"
          :isHome="true"
          @click="handleCardClickPresenti"
          :isRouter="true"
        ></CardComponent>
      </el-col>
      <el-col :xs="24" :sm="12" :md="8">
        <CardComponent
          :imgSrc="corseFutureImg"
          title="AGENDA"
          label="Prenotazioni future"
          linkPath="/corse/corse_future"
          @click="handleCardClickFuture"
          :isRouter="true"
        ></CardComponent>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import corsePassateImg from "../assets/passati.png"
import corseAttiveImg from "../assets/attivi.png"
import corseFutureImg from "../assets/futuri.png"
import CardComponent from '@/Components/CardComponent.vue';
import { useRouter } from 'vue-router';

export default {
  name: "CorsePage",
  components: {
    CardComponent
  },
  setup() {
    const router = useRouter();

    const handleCardClickPassate = () => {
      router.push('/corse/corse_passate');
    };

    const handleCardClickPresenti = () => {
      router.push('/');
    };

    const handleCardClickFuture = () => {
      router.push('/corse/corse_future');
    };

    return {
      corsePassateImg,
      corseAttiveImg,
      corseFutureImg,
      handleCardClickPassate,
      handleCardClickPresenti,
      handleCardClickFuture
    };
  },
};
</script>

<style scoped>
.page-wrapper {
  padding: 24px;
  max-width: 1400px;
  margin: 0 auto;
}

.page-title-section {
  margin-bottom: 32px;
}

.page-title {
  font-size: 1.75rem;
  font-weight: 700;
  color: #171717;
  margin: 0 0 8px 0;
  padding-bottom: 12px;
  border-bottom: 3px solid #4B30F2;
  display: inline-block;
}

.page-subtitle {
  font-size: 0.95rem;
  color: #737373;
  margin: 0;
}

.cards-row {
  margin-top: 40px;
}

@media (max-width: 768px) {
  .page-wrapper {
    padding: 16px;
  }

  .cards-row {
    margin-top: 24px;
  }
}
</style>
